var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { onError } from "@ane/core/lib/decorators/OnError";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
class GarExpApiResource extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.legacy, "/api");
    __publicField(this, "_errorMessage", (RestResult, response) => {
      return response && response.ExceptionMessage;
    });
  }
  getExperimentPlanId(stepId) {
    return __async(this, null, function* () {
      const address = `/analysis/internal/stepProperties?experimentStepId=${stepId}`;
      const result = yield this._get(address);
      return result;
    });
  }
  getExperimentInfo(planId) {
    return __async(this, null, function* () {
      const address = `/2.0/experiments/${planId}`;
      const result = yield this._get(address);
      return result;
    });
  }
  getPlanSummary(stepId) {
    return __async(this, null, function* () {
      const address = `/experiments/steps/${stepId}/planSummary`;
      return yield this._get(address);
    });
  }
}
__decorateClass([
  onError({ message: `An error occurred.` })
], GarExpApiResource.prototype, "getExperimentPlanId", 1);
__decorateClass([
  onError({ message: `An error occurred.` })
], GarExpApiResource.prototype, "getExperimentInfo", 1);
__decorateClass([
  onError({ message: `An error occurred.` })
], GarExpApiResource.prototype, "getPlanSummary", 1);
const GarExpApiResource$1 = new GarExpApiResource();
export {
  GarExpApiResource$1 as default
};
//# sourceMappingURL=GarExpApi.resource.js.map
